import React, { useState, ChangeEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faKey } from '@fortawesome/free-solid-svg-icons'
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import { changePassword } from '../../store/actions/auth';
import TextInput from '../../components/TextInput';
import { getItemFromStorage, checkFieldValidation, checkProperties } from '../../services/utilService';
import update from 'react-addons-update';
import { IFormState } from '../../shared/models/validations';

const ChangePassword = (props: any) => {

    const [changePwdForm, setChangePwdForm] = useState<IFormState>({
        values: {
            oldPassword:"",
            newPassword:"",
            confirmPassword:""
        },
        valid: false,
        errors: {},
        validations : {
            oldPassword : {
                label:'Old Password',
                required: true,
            },
            newPassword: {
                label:'New Password',
                required: true,
                password: true,
            },
            confirmPassword:{
                label:"Confirm Password",
                required: true,
                passwordMatch: true
            }
        }
    });

    const handleChange = (e:ChangeEvent<HTMLInputElement>) => {
        const { name, value} = e.target;
        const validations = changePwdForm.validations;
        let error = '';
        let confirmPasswordError = '';
        if(Object.keys(validations).includes(name)) {
            let secondValue = null;
            if(name === 'confirmPassword') {
                secondValue= values.newPassword;
            } 
            if(name === 'newPassword') {
              confirmPasswordError = checkFieldValidation(validations['confirmPassword'],values.confirmPassword,values.newPassword) || '';
            }
            error = checkFieldValidation(validations[name],value,secondValue) || '';
        }
        setChangePwdForm(update(changePwdForm,{
            values:{
                [name] : { $set :value}
            },
            errors:{
                'confirmPassword' :  name === 'newPassword' ? {$set : confirmPasswordError} : {$set: ''},
                [name] : { $set :error}
            }
        }));
    }

    const checkFormValidation = () => {
        let errors : any = {};
        // type IValidation = keyof ILoginState;
        const validations = changePwdForm.validations;
        Object.keys(validations).forEach((field : any) => {
            let secondValue = null;
            if(field === 'confirmPassword') {
                secondValue= values.newPassword;
            }
            errors[field] = checkFieldValidation(validations[field],changePwdForm.values[field],secondValue);
        });
        return errors;
    }
    const { errors,values } = changePwdForm;

    const changePassword = async(e) => {
        e.preventDefault();
        const errors = await checkFormValidation();
        const form = {
            ...changePwdForm,
            errors,
        }
        setChangePwdForm(form);
        const noError = checkProperties(form.errors);
        if (noError) {
            const userDetail = getItemFromStorage('user');
            const params = {
                email:userDetail.email,
                oldPassword : values.oldPassword,
                newPassword : values.newPassword
            }
            const reset = await props.doChangePassword(params);
            if (reset) {
                props.history.push('/login');
            }
        }
    }
    return (
    <div className="login-center change-password">
        <div className="login-wrapper">
            {/* <div className="login-top">
                <img src="assets/images/logo.png" />
            </div> */}
            <div className="text-center mb-3">
               <h3>Change Password</h3>
            </div>
            <div className="login-content">
                <form className="witt-form login-form">
                <div className="form-group">
                        <FontAwesomeIcon icon={faKey} />
                        <TextInput  
                        type="password"
                        placeholder="Current Password" 
                        value={values.oldPassword}
                        name="oldPassword"
                        error={errors.oldPassword}
                        onChange={handleChange}
                         />
                    </div>
                    <div className="form-group">
                        <FontAwesomeIcon icon={faKey} />
                        <TextInput  
                        type="password"
                        placeholder="New Password" 
                        value={values.newPassword}
                        name="newPassword"
                        error={errors.newPassword}
                        onChange={handleChange}
                         />
                    </div>
                  
                    <div className="form-group">
                        <FontAwesomeIcon icon={faKey} />
                        <TextInput  
                        type="password"
                        placeholder="Confirm Password" 
                        value={values.confirmPassword}
                        name="confirmPassword"
                        error={errors.confirmPassword}
                        onChange={handleChange}
                         />
                    </div>
                    <div className="login-action text-center">
                        <button disabled={props.isLoading} type="submit" className="btn btn-primary w-100" onClick={(e: any) => changePassword(e)}>Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
   )
}

const mapStateToProps = (state: any) => ({
    isLoading: state.common.isLoading
})


const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    doChangePassword:  bindActionCreators(changePassword,dispatch),
});

        
export default connect(mapStateToProps,mapDispatchToProps)(ChangePassword);